import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

export default function ComplimentsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="contact" className="relative bg-ink overflow-hidden">
      {/* Geometric pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="geo-dark" x="0" y="0" width="80" height="80" patternUnits="userSpaceOnUse">
              <polygon points="40,5 75,25 75,55 40,75 5,55 5,25" fill="none" stroke="#C68E5F" strokeWidth="0.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#geo-dark)" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-24 md:py-32 text-center" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 1 }}
        >
          <motion.div
            animate={{ scale: [1, 1.15, 1] }}
            transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
          >
            <i className="ri-heart-3-fill text-copper/40 w-6 h-6 flex items-center justify-center mx-auto mb-6" />
          </motion.div>

          <h3 className="font-display text-xl md:text-2xl lg:text-3xl text-cream/80 font-light tracking-wide">
            With best compliments from friends and family
          </h3>
        </motion.div>
      </div>
    </section>
  );
}